<div class="flex flex-col">
  <div
    *ngFor="let event of reversedEvents; let i = index"
    class="border-s200 border-b"
  >
    <div
      class="flex min-w-0 cursor-pointer select-none flex-row items-center px-4 py-2 hover:bg-gray-50"
      (click)="toggleEvent(event.eventId)"
    >
      <span class="text-s400 flex-shrink-0 text-base">{{
        expandedEvents[event.eventId] ? '▼' : '▶'
      }}</span>

      <span class="text-s500 ml-2 w-8 flex-shrink-0 text-right text-base">{{
        event.eventIndex
      }}</span>

      <span class="text-s1 ml-5 min-w-0 truncate font-mono text-base">{{
        event.eventType
      }}</span>

      <span
        class="text-s1 ml-[100px] min-w-0 truncate font-mono text-base font-semibold"
        >{{ getEventRole(event) }}</span
      >

      <span
        *ngIf="getPartType(event)"
        class="text-s500 ml-4 min-w-0 truncate font-mono text-base"
        >{{ getPartType(event) }}</span
      >

      <span
        *ngIf="getPartTool(event)"
        class="ml-2 min-w-0 truncate font-mono text-base text-amber-600"
        >{{ getPartTool(event) }}</span
      >
    </div>

    <div *ngIf="expandedEvents[event.eventId]" class="bg-s50 px-4 py-3">
      <pre
        class="text-s1 overflow-x-auto whitespace-pre-wrap break-words font-mono text-base"
        >{{ getPayloadJson(event) }}</pre
      >
    </div>
  </div>

  <div
    *ngIf="events.length === 0"
    class="text-s500 flex items-center justify-center py-8 text-sm"
  >
    No events yet
  </div>
</div>
